import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const Logo = ({ light = false, testId = "site-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex shrink-0 items-center gap-3" aria-label="Kfz-Sachverständiger Francesco Marcone – zur Startseite">
    <span className={cn("flex items-center transition-transform duration-300 group-hover:-translate-y-0.5", light && "rounded-xl bg-white px-3 py-2")}>
      <img src="/images/logo-tuev-fsp.webp" alt="TÜV Rheinland FSP" width="545" height="144" className={cn("w-auto", light ? "h-8" : "h-10 sm:h-11")} />
    </span>
    <span className={cn("hidden border-l pl-3 leading-tight sm:block lg:hidden xl:block", light ? "border-white/20" : "border-brand-anthracite/25")}>
      <span className={cn("block text-[15px] font-bold tracking-tight", light ? "text-white" : "text-brand-anthracite")}>Francesco Marcone</span>
      <span className={cn("block text-[10.5px] font-semibold uppercase tracking-[0.14em]", light ? "text-white/70" : "text-brand-anthracite/80")}>
        Kfz-Sachverständiger · Köln
      </span>
    </span>
  </Link>
);
